import { LabsGqlDoctorNotificationChannel } from '@orthly/graphql-schema';
import { NameForNotificationChannel } from '@orthly/veneer';

export const smsLabel = NameForNotificationChannel[LabsGqlDoctorNotificationChannel.Sms];
export const emailLabel = NameForNotificationChannel[LabsGqlDoctorNotificationChannel.Email];
